import { useEffect } from 'react';
import { TEXT_SCALE_OPTIONS } from '@/hooks/useTextScale';

/**
 * Component that initializes the text scale from localStorage on app load.
 * This ensures the user's preferred text size is applied immediately.
 * 
 * Only applies to study content (questions, options, explanations),
 * NOT to headers, progress, or navigation.
 */
export function TextScaleInitializer() {
  useEffect(() => {
    // Read saved preference and apply CSS variable immediately
    const saved = localStorage.getItem('mblearn-text-scale');
    const config = TEXT_SCALE_OPTIONS.find(opt => opt.level === saved) || TEXT_SCALE_OPTIONS[0];
    
    document.documentElement.style.setProperty('--study-text-scale', config.multiplier.toString());
    console.log('📐 [TextScale] Initialized with scale level:', config.level, 'multiplier:', config.multiplier);
  }, []);
  
  return null;
}
